import { gql } from '@apollo/client';

export const TOOL_ORDER_CHECKINS = gql`
  mutation ToolCheckIn($toolCheckInInput: ToolCheckInInput!) {
    toolCheckIn(toolCheckInInput: $toolCheckInInput) {
      toolCheckIn {
        id
        checkInNumber
        recipientId
        thTransactionId
        createdDate
        createdBy
        projectId
        toolRoomId
        toolCheckInItems {
          id
          quantity
          createdDate
          createdBy
          toolInventoryId
          toolCatalogId
          projectId
          toolCheckInId
        }
      }
      errors {
        toolRoomId
        error
        toolCatalogId
        toolInventoryId
      }
    }
  }
`;
